import { FULL_HD, HD } from '@bedrock-rdk/constants';
import { makeDefaultStylingContext } from '../../../tornado/utils/style';

export const defaultContext = makeDefaultStylingContext();

export const ICON_HEIGHT = {
  [HD]: 24,
  [FULL_HD]: 32,
};

export const getInitialStyle = (context = defaultContext) => {
  const { screenSize } = context;

  return {
    h: ICON_HEIGHT[screenSize],
  };
};
